export default __webpack_public_path__ + "3fe193a72cc4dc42681537f6c9e40b84.png";